/** @format */

const template = `
<ng-form name="literatureForm">
  <div class="row literature-item" ng-repeat="item in ctrl.literature">
    <div class="col-4 col-md-5">
      <div class="select-wrapper">
        <select
          name="type"
          aria-label="{{'SIS_COMPONENTS.LITERATURE.LITERATURE_EDITOR.SELECT_TYPE' | translate}}"
          class="form-select"
          ng-model="item.type"
          ng-required="true"
          valdr-no-validate="true">
          <option disabled translate="SIS_COMPONENTS.LITERATURE.LITERATURE_EDITOR.SELECT_TYPE"></option>
          <option ng-repeat="type in ctrl.possibleTypes" value="{{type}}"
            >{{ 'SIS_COMPONENTS.LITERATURE.LITERATURE_EDITOR.' + type | translate }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-6">
      <ng-switch on="item.type">
        <div ng-switch-when="LiteratureReference">
          <url-editor name="url" ng-model="item.url" max-length="{{ctrl.literatureUrlMaxLength}}" required="!!item.type"> </url-editor>
        </div>
        <div ng-switch-default>
          <input
            class="form-control name-input"
            type="text"
            name="name"
            ng-model="item.name"
            ng-maxlength="{{ctrl.literatureNameMaxLength}}"
            ng-minlength="{{ctrl.literatureNameMinLength}}"
            ng-required="!!item.type"
            valdr-no-validate="true" />
        </div>
      </ng-switch>
    </div>

    <div class="col-2 col-md-1 button-col">
      <button
        type="button"
        id="delete-button"
        class="btn btn-primary btn-naked btn-lg form-control btn-just-icon"
        ng-click="ctrl.remove(item)"
        aria-label="{{::'ARIA_LABEL.DELETE_LITERATURE' |translate}}">
        <sis-icon icon="delete"></sis-icon>
      </button>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <ul class="error-list">
        <li ng-if="ctrl.atLeastOneErrorWithName('required', 'type') && literatureForm.$dirty" translate
          >SIS_COMPONENTS.LITERATURE.LITERATURE_EDITOR.TYPE_MISSING
        </li>

        <li ng-if="ctrl.atLeastOneErrorWithName('required', 'name') && literatureForm.name.$dirty" translate
          >SIS_COMPONENTS.LITERATURE.LITERATURE_EDITOR.NAME_MISSING
        </li>

        <li ng-if="ctrl.atLeastOneErrorWithName('required', 'url') && literatureForm.url.$dirty" translate
          >SIS_COMPONENTS.LITERATURE.LITERATURE_EDITOR.URL_MISSING
        </li>

        <li ng-if="ctrl.atLeastOneErrorWithName('pattern', 'url') && literatureForm.url.$dirty" translate
          >SIS_COMPONENTS.LITERATURE.LITERATURE_EDITOR.URL_PATTERN
        </li>

        <li ng-if="ctrl.form.$error[ctrl.name + '.too_many']" translate translate-values="{ maxCount: ctrl.maxCount }"
          >SIS_COMPONENTS.LITERATURE.LITERATURE_EDITOR.TOO_MANY
        </li>

        <li
          ng-if="ctrl.atLeastOneErrorWithName('maxlength', 'name')"
          translate-value-max-count="{{::ctrl.literatureNameMaxLength}}"
          translate
          >SIS_COMPONENTS.LITERATURE.LITERATURE_EDITOR.NAME_MAX_LENGTH
        </li>

        <li ng-if="ctrl.atLeastOneErrorWithName('maxlength', 'url')" translate-value-max-count="{{::ctrl.literatureUrlMaxLength}}" translate
          >SIS_COMPONENTS.LITERATURE.LITERATURE_EDITOR.URL_MAX_LENGTH
        </li>
      </ul>
    </div>
  </div>

  <button type="button" class="link-button" id="add-new-literature" ng-click="ctrl.addNew()">
    <sis-icon icon="ring-plus"></sis-icon>{{'SIS_COMPONENTS.LITERATURE.LITERATURE_EDITOR.ADD' | translate}}
  </button>
</ng-form>
`;
export default template;
